// extracted by mini-css-extract-plugin
export default {"inputs":"MediaForm_inputs__gztbc","actions":"MediaForm_actions__7GaV1","dropzone":"MediaForm_dropzone__Zm4dg","fileWrapper":"MediaForm_fileWrapper__03uVz"};